import axios, {AxiosInstance} from "axios";
import {useSelector} from "react-redux";
import {RootState} from "./app/store";
import {store} from './app/store'
//
function listener() {
    let state = store.getState()
    axios.defaults.baseURL = state.auth.url;
}
// let state = store.getState()


let _axios : AxiosInstance = axios.create({
    baseURL: store.getState().auth.url,
    // baseURL : state.auth.url,
    headers: {
        "Content-type": "application/json",
    },
})


    store.subscribe(()=>{
        let state = store.getState()
        _axios.defaults.baseURL = state.auth.url
    if(!_axios.defaults.headers.common['Authorization'] && localStorage.getItem("token"))
        _axios.defaults.headers.common['Authorization'] = localStorage.getItem("token")!
    else
        console.log('')


})

const setAxiosToken = (token : string) =>{
    _axios.defaults.headers.common['Authorization'] = token
}

const orignalURI = 'https://pkdservers.com/RPM-Super/api'

export{
    _axios,
    setAxiosToken,
    orignalURI
}
